import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { Link } from 'react-router-dom';
import packageJson from '../../package.json';
import { enableTestAuth, signOut } from '../auth/msal';
import { LoginButton } from './LoginButton';

// Coffee Run Header Component - Original Implementation
export const Header: React.FC = () => {
  const isAuthenticated = useIsAuthenticated();
  const { accounts, instance } = useMsal();

  // Fallback: in test auth mode treat presence of mock account as authenticated
  const effectiveAuthenticated =
    isAuthenticated || (enableTestAuth && accounts.length > 0);

  const userDisplayName = accounts[0]?.name || accounts[0]?.username || 'User';

  // Debug logging
  console.log('Header render - isAuthenticated:', isAuthenticated);
  console.log('Header render - accounts:', accounts);
  console.log('Header render - active account:', instance.getActiveAccount());

  return (
    <header className="bg-white shadow">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center space-x-2">
            <span className="text-2xl">☕</span>
            <div className="flex items-center space-x-2">
              <h1 className="text-xl font-bold text-gray-900">Coffee Run</h1>
              <span className="text-xs bg-coffee-100 text-coffee-700 px-2 py-1 rounded-full font-medium">
                v{packageJson.version}
              </span>
              {enableTestAuth && (
                <span className="text-[10px] bg-purple-100 text-purple-700 px-2 py-1 rounded-full font-semibold tracking-wide">
                  TEST AUTH
                </span>
              )}
            </div>
          </Link>

          <nav className="hidden md:flex items-center space-x-6">
            <Link
              to="/"
              className="text-gray-600 hover:text-gray-900 font-medium"
            >
              Runs
            </Link>
            {effectiveAuthenticated && (
              <>
                <Link
                  to="/run/new"
                  className="text-gray-600 hover:text-gray-900 font-medium"
                >
                  Create Run
                </Link>
                <Link
                  to="/history"
                  className="text-gray-600 hover:text-gray-900 font-medium"
                >
                  History
                </Link>
              </>
            )}
          </nav>

          <div className="flex items-center space-x-4">
            {effectiveAuthenticated ? (
              <div className="flex items-center space-x-3">
                <span className="text-sm text-gray-600">
                  Welcome, {userDisplayName}
                </span>
                <button onClick={signOut} className="btn-secondary text-sm">
                  Sign out
                </button>
              </div>
            ) : (
              <LoginButton />
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
